const BREEDS_KEY = 'breeds';
const BREEDS_VER_KEY = 'breeds_version';

function parse(json, fallback) {
  try { return JSON.parse(json); } catch { return fallback; }
}

function setAll(list) { localStorage.setItem(BREEDS_KEY, JSON.stringify(list || [])); }
function setVersion(v) { localStorage.setItem(BREEDS_VER_KEY, v || ''); }
function save(version, list) { setVersion(version); setAll(list); }

function getAll() { return parse(localStorage.getItem(BREEDS_KEY), []); }
function getVersion() { return localStorage.getItem(BREEDS_VER_KEY)}

function getByLevel(level) {
  if (level == null || level === '') return [];
  const lv = String(level).trim().toLowerCase();
  return getAll().filter(b => String(b?.level ?? '').trim().toLowerCase() === lv);
}

function getBySpecies(species, opts = {}) {
  const by = opts.by || 'species'; // 'species' | 'species_code'
  if (!species) return [];
  const target = String(species).trim().toLowerCase();
  return getAll().filter(b => String(b?.[by] ?? '').trim().toLowerCase() === target);
}

/** ✅ species(+옵션으로 species_code)와 level 동시 필터 */
function getBySpeciesLevel(species, level, opts = {}) {
  const by = opts.by || 'species'; // 'species' | 'species_code'
  if (!species) return [];
  const s = String(species).trim().toLowerCase();
  const lv = level == null ? '' : String(level).trim().toLowerCase();

  return getAll().filter(b => {
    const matchS = String(b?.[by] ?? '').trim().toLowerCase() === s;
    if (!matchS) return false;
    if (!lv) return true; // level 미지정이면 species만 매칭
    return String(b?.level ?? '').trim().toLowerCase() === lv;
  });
}

function clear() {
  localStorage.removeItem(BREEDS_KEY);
  localStorage.removeItem(BREEDS_VER_KEY);
}

export default {
  save, setAll, setVersion, getAll, getVersion, getByLevel, getBySpecies, getBySpeciesLevel, clear
};